import './MenuItemStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Message } from 'src/core/components';
import Header from 'src/core/components/Title/components/Header';

const isActive = (selectedMenuItem, category, subcategory, isViewAllActive) => {
  const selectedCategory = selectedMenuItem.category.name;
  const selectedSubcategory = selectedMenuItem.subcategory?.name;

  if (isViewAllActive) {
    return true;
  }

  return selectedCategory === category && selectedSubcategory === subcategory;
};

const MenuItem = ({
  category,
  subcategory,
  onSelectMenuItem,
  selectedMenuItem,
  font,
  label,
  isViewAllActive,
}) => {
  let menuItemClassName = 'mcp-menu-item';
  const labelMessage = label ? <Message message={label} /> : subcategory?.name;

  if (
    isActive(
      selectedMenuItem,
      category.name,
      subcategory?.name,
      isViewAllActive
    )
  ) {
    menuItemClassName = `${menuItemClassName} mcp-menu-item--active`;
  }

  return (
    <div
      className={menuItemClassName}
      onClick={() =>
        onSelectMenuItem({
          searchText: selectedMenuItem?.searchText || '',
          category,
          subcategory,
          filter: {},
          resetFilter: true,
        })
      }
    >
      <Header size="5" font={font}>
        {labelMessage}
      </Header>
    </div>
  );
};

MenuItem.propTypes = {
  category: PropTypes.object.isRequired,
  subcategory: PropTypes.object,
  selectedMenuItem: PropTypes.object,
  font: PropTypes.string,
  onSelectMenuItem: PropTypes.func,
  label: PropTypes.object,
  isViewAllActive: PropTypes.bool,
};

export default MenuItem;
